module.exports = __webpack_public_path__ + "img/background.bdc3bc83.jpg";